/* eslint-disable react/no-danger */
import React from 'react';
import { useTranslation } from 'react-i18next';

const ObjectiveDrills = ({ drills }) => {
    const { t: translate } = useTranslation();
    const orderedDrills = [...drills].sort((a, b) => {
        const ord = a.SortOrder - b.SortOrder;
        return ord !== 0 ? ord : a.Drill.Name.localeCompare(b.Drill.Name);
    });

    return (
        <div>
            <div>{translate('sections.my-objectives.drills')}</div>
            <div className="mt-1">
                {orderedDrills.map((drill) => (drill.Drill.URL
                    ? (
                        <div key={drill.DrillID}>
                            <a href={drill.Drill.URL} target="_blank" dangerouslySetInnerHTML={{ __html: drill.Drill.Name }} rel="noreferrer" />
                        </div>
                    ) : <div dangerouslySetInnerHTML={{ __html: drill.Drill.Name }} key={drill.DrillID} />))}
            </div>
        </div>
    );
};

export default ObjectiveDrills;
